import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Edit, Trash2 } from "react-feather";
import Select from "react-select";
import Table from "../../core/pagination/datatable";
import PageHeader from "../components/PageHeader";
import confirmDelete from "../components/confirmDelete";
import ProductModal from "../../core/modals/products/ProductModal";
import { fetchProducts, deleteProductThunk } from "../../core/redux/slices/productSlice";
import { fetchSuppliers } from "../../core/redux/slices/supplierSlice";

const categoryFilter = [
  { value: "", label: "All Categories" },
  { value: "Medicine", label: "Medicine" },
  { value: "Consumable", label: "Consumable" },
];

const ProductList = () => {
  const dispatch = useDispatch();
  const { list, loading } = useSelector((s) => s.products);
  const [search, setSearch] = useState("");
  const [catFilter, setCatFilter] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editRecord, setEditRecord] = useState(null);

  useEffect(() => { dispatch(fetchProducts()); dispatch(fetchSuppliers()); }, [dispatch]);

  const data = useMemo(() => {
    const q = search.toLowerCase();
    return list.filter((p) =>
      (!q || p.itemName?.toLowerCase().includes(q)) &&
      (!catFilter || p.itemCategory === catFilter)
    );
  }, [list, search, catFilter]);

  const openAdd = () => { setEditRecord(null); setShowModal(true); };
  const openEdit = (rec) => { setEditRecord(rec); setShowModal(true); };
  const closeModal = () => { setShowModal(false); setEditRecord(null); dispatch(fetchProducts()); };

  const columns = [
    { title: "Item Name", dataIndex: "itemName", sorter: (a, b) => a.itemName.localeCompare(b.itemName) },
    { title: "Category", dataIndex: "itemCategory", width: 110,
      render: (v) => <span className={`badge bg-${v === "Medicine" ? "primary" : "info"}`}>{v}</span> },
    { title: "Unit", dataIndex: "unit", width: 80 },
    { title: "Purchase Rate", dataIndex: "purchaseRate", align: "right", width: 120,
      render: (v) => `₹${Number(v || 0).toLocaleString("en-IN")}` },
    { title: "Selling Rate", dataIndex: "sellingRate", align: "right", width: 110,
      render: (v) => `₹${Number(v || 0).toLocaleString("en-IN")}` },
    { title: "Current Stock", dataIndex: "currentStock", align: "center", width: 110,
      render: (v, rec) => (
        <span className={v != null && rec.minimumStockLevel && v <= rec.minimumStockLevel ? "text-danger fw-bold" : ""}>
          {v ?? "—"}
        </span>
      ) },
    { title: "Min Stock", dataIndex: "minimumStockLevel", align: "center", width: 90 },
    { title: "Status", dataIndex: "status", width: 90,
      render: (v) => <span className={`badge bg-${v === "Active" ? "success" : "danger"}`}>{v}</span> },
    {
      title: "Action", dataIndex: "action", width: 100,
      render: (_, rec) => (
        <div className="edit-delete-action d-flex">
          <button className="me-2 p-2 btn btn-sm" onClick={() => openEdit(rec)}><Edit size={15} /></button>
          <button className="p-2 btn btn-sm text-danger" onClick={() => confirmDelete(() => dispatch(deleteProductThunk(rec.id)), rec.itemName)}>
            <Trash2 size={15} />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <PageHeader title="Products" subtitle="Manage medicines and consumables" onAdd={openAdd} addLabel="Add Product" />
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top d-flex gap-2 flex-wrap">
              <div className="search-input flex-grow-1">
                <input type="text" placeholder="Search products..."
                  className="form-control form-control-sm formsearch"
                  value={search} onChange={(e) => setSearch(e.target.value)} />
              </div>
              <div style={{ minWidth: 180 }}>
                <Select classNamePrefix="react-select" options={categoryFilter}
                  defaultValue={categoryFilter[0]}
                  onChange={(opt) => setCatFilter(opt?.value || "")} />
              </div>
            </div>
            <div className="table-responsive">
              <Table columns={columns} dataSource={data} loading={loading} />
            </div>
          </div>
        </div>
      </div>
      <ProductModal show={showModal} onClose={closeModal} editRecord={editRecord} />
    </div>
  );
};

export default ProductList;
